import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { ErrorLog } from '../../models/error-log';
import { environment } from '../../../environments/environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private zone = inject(NgZone);
    private http = inject(HttpClient);

    private readonly _baseUrl = environment.baseUrl;

    handleError(error: any): void {
        if (
            !(error instanceof HttpErrorResponse) &&
            error instanceof ErrorLog
        ) {
            console.log(error);
            this.zone.run(() =>
                this.http
                    .post(`${this._baseUrl}/api/v2/telemetry`, error)
                    .subscribe()
            );
        }
    }
}
